import Skyeye from 'skyeye-javascript'

const isProd = process.env.VUE_APP_MODE === 'prod' && process.env.NODE_ENV === 'production'

console.log('isProd', isProd)

const skyeye = new Skyeye({
  client: '2fafa4c3-4ce0-4594-98b6-cb2dd965d8e4', // 客户端ID （必填）需要去天眼后端创建
  url: 'https://skyeye-report-sml.esign.cn:3002', // 错误上报地址（非必填）
  ignoreResource: false, // 过滤资源报错（非必填）默认false
  isProd, // 是否为正式环境 （必填）
  ignore: [], // 忽略报错（非必填） 支持正则过滤、函数过滤
  openTraceLog: false, // 开启行为追踪（非必填） 记录用户行为数据 主要包括页面点击、页面访问、接口请求
  traceLimit: 50, // （非必填） 默认50个行为记录 保存到本地的用户行为数据的限定
  traceAutoUpload: false, // 行为记录全量上传。（非必填）默认关闭
  router: null, // vue-router（非必填）用户记录页面跳转数据
})

window.$skyeye = skyeye
